/* *
 * AscendServiceModal 📜 Shared Service Info Modal
 * Uses the same visual style as the academic service-modal.
 * Exposes: window.AscendServiceModal.show({ icon, name, desc, features, price, priceLabel, serviceCode, category }) */
(function () {
  "use strict";

  function injectStyles() {
    if (document.getElementById("ascend-sim-css")) return;
    const s = document.createElement("style");
    s.id = "ascend-sim-css";
    s.textContent = `
      .ascend-sim {
        display: none; position: fixed; inset: 0; z-index: 9998;
        align-items: center; justify-content: center; padding: 1rem;
      }
      .ascend-sim.active { display: flex; }
      .ascend-sim-backdrop {
        position: absolute; inset: 0;
        background: rgba(0,0,0,0.82); backdrop-filter: blur(8px);
      }
      .ascend-sim-container {
        background: var(--color-bg-card, #1a1a2e);
        border: 1px solid var(--border-color, rgba(255,255,255,0.1));
        border-radius: 1.5rem; max-width: 680px; width: 100%;
        position: relative; z-index: 1; max-height: 90vh;
        overflow: hidden; display: flex; flex-direction: column;
      }
      .ascend-sim-header {
        padding: 1.75rem 2rem;
        border-bottom: 1px solid var(--border-color, rgba(255,255,255,0.1));
        display: flex; align-items: center; gap: 1rem;
      }
      .ascend-sim-icon { font-size: 2.25rem; flex-shrink: 0; }
      .ascend-sim-title {
        font-size: 1.4rem; font-weight: 700;
        color: var(--color-text-primary, #fff); flex: 1; margin: 0;
      }
      .ascend-sim-close {
        width: 38px; height: 38px;
        background: var(--color-bg-elevated, rgba(255,255,255,0.07));
        border: 1px solid var(--border-color, rgba(255,255,255,0.1));
        border-radius: 50%; color: var(--color-text-primary, #fff);
        font-size: 1.4rem; cursor: pointer; flex-shrink: 0;
        display: flex; align-items: center; justify-content: center;
        transition: background 0.2s;
      }
      .ascend-sim-close:hover { background: rgba(255,255,255,0.15); }
      .ascend-sim-body { padding: 2rem; overflow-y: auto; flex: 1; }
      .ascend-sim-desc {
        color: var(--color-text-secondary, rgba(255,255,255,0.7));
        line-height: 1.8; margin-bottom: 1.5rem; white-space: pre-line;
        font-size: 0.95rem;
      }
      .ascend-sim-section { margin-bottom: 1.5rem; }
      .ascend-sim-section h4 {
        color: var(--color-text-primary, #fff); margin: 0 0 0.75rem; font-size: 1rem; font-weight: 600;
      }
      .ascend-sim-features { list-style: none; padding: 0; margin: 0; display: grid; gap: 0.55rem; }
      .ascend-sim-features li {
        display: flex; align-items: flex-start; gap: 0.65rem;
        color: var(--color-text-secondary, rgba(255,255,255,0.7)); font-size: 0.9rem;
      }
      .ascend-sim-features li::before {
        content: '📜'; color: var(--accent-color, #10b981); font-weight: 700; flex-shrink: 0; margin-top: 1px;
      }
      .ascend-sim-accompanying-item {
        display: flex; justify-content: space-between; align-items: center;
        gap: 0.75rem; padding: 0.65rem 1rem;
        background: var(--color-bg-elevated, rgba(255,255,255,0.04));
        border: 1px solid var(--border-color, rgba(255,255,255,0.08));
        border-radius: 0.6rem; margin-top: 0.5rem; font-size: 0.85rem;
      }
      .ascend-sim-accompanying-item-name {
        color: var(--color-text-secondary, rgba(255,255,255,0.75));
        display: flex; flex-direction: column; gap: 2px;
      }
      .ascend-sim-accompanying-item-name .plus-icon {
        color: var(--accent-color, #10b981); font-weight: 700; margin-right: 4px;
      }
      .ascend-sim-accompanying-item-note {
        font-size: 0.7rem; color: var(--color-text-muted, rgba(255,255,255,0.45)); font-style: italic;
      }
      .ascend-sim-accompanying-item-price {
        color: var(--accent-color, #10b981); font-weight: 600; white-space: nowrap;
      }
      .ascend-sim-accompanying-item-price .original {
        text-decoration: line-through; color: var(--color-text-muted, rgba(255,255,255,0.4));
        font-weight: 400; font-size: 0.8em; margin-right: 4px;
      }
      .ascend-sim-accompanying-discount-note {
        font-size: 0.7rem; color: var(--color-text-muted, rgba(255,255,255,0.45));
        margin-top: 4px; padding: 0 2px;
      }
      .ascend-sim-price {
        display: flex; justify-content: space-between; align-items: center;
        padding: 1rem 1.25rem;
        background: var(--color-bg-elevated, rgba(255,255,255,0.05));
        border-radius: 0.75rem; margin-top: 0.5rem;
      }
      .ascend-sim-price-label {
        color: var(--color-text-secondary, rgba(255,255,255,0.6)); font-size: 0.85rem;
      }
      .ascend-sim-price-value {
        font-size: 1.35rem; font-weight: 700; color: var(--accent-color, #10b981);
      }
      .ascend-sim-footer {
        padding: 1.25rem 2rem;
        border-top: 1px solid var(--border-color, rgba(255,255,255,0.1));
        display: flex; gap: 0.75rem; justify-content: flex-end;
      }
      .ascend-sim-btn-close {
        padding: 0.7rem 1.4rem; border-radius: 0.5rem; cursor: pointer;
        border: 1px solid var(--border-color, rgba(255,255,255,0.2));
        background: transparent; color: var(--color-text-primary, #fff);
        font-size: 0.92rem; transition: background 0.2s;
      }
      .ascend-sim-btn-close:hover { background: rgba(255,255,255,0.07); }
      .ascend-sim-btn-basket {
        padding: 0.7rem 1.4rem; border-radius: 0.5rem; cursor: pointer;
        border: none; background: var(--accent-color, #10b981);
        color: #fff; font-size: 0.92rem; font-weight: 600;
        display: flex; align-items: center; gap: 0.5rem; transition: opacity 0.2s;
      }
      .ascend-sim-btn-basket:hover { opacity: 0.88; }
      .ascend-sim-btn-basket.in-basket { background: #16a34a; }
      @media (max-width: 640px) {
        .ascend-sim-container { border-radius: 1rem; }
        .ascend-sim-header, .ascend-sim-body, .ascend-sim-footer { padding: 1.25rem; }
        .ascend-sim-title { font-size: 1.15rem; }
        .ascend-sim-footer { flex-direction: column-reverse; }
        .ascend-sim-btn-close, .ascend-sim-btn-basket { width: 100%; justify-content: center; }
      }
    `;
    document.head.appendChild(s);
  }

  let el = null;

  function close() {
    if (el) {
      el.classList.remove("active");
      document.body.style.overflow = "";
    }
  }

  /* *
   * @param {object} opts
   * @param {string}   [opts.icon]        Emoji or text icon
   * @param {string}   opts.name          Service name
   * @param {string}   [opts.desc]        Description HTML (supports embedded tags; plain
   *                                      text with \n also renders correctly via
   *                                      white-space:pre-line)
   * @param {string[]} [opts.features]    "What's Included" bullet list
   * @param {number|string|null} [opts.price]  Numeric or formatted price string
   * @param {string}   [opts.priceLabel]  Label before price (default "Starting from")
   * @param {string}   [opts.serviceCode] id/code for basket item
   * @param {string}   [opts.category]    Category string for basket
   * @param {boolean}  [opts.showFooter]  Show the Close/Add-to-Basket footer
   *                                      (default true) — set false for a pure
   *                                      info popup with no purchase action
   * @param {Array}    [opts.accompanyingServices] Cross-sell add-ons configured
   *                                      in the Service Catalog (e.g. Dissertation
   *                                      + Presentation) — each keeps its own
   *                                      independent price/discount, shown merged
   *                                      into this modal and added as its own
   *                                      basket line item on Add to Basket. */
  function show(opts) {
    const {
      icon = "",
      name = "",
      desc = "",
      features = [],
      price = null,
      priceLabel = "Starting from",
      serviceCode,
      category = null,
      showFooter = true,
      accompanyingServices = [],
    } = opts || {};

    injectStyles();

    if (!el) {
      el = document.createElement("div");
      el.className = "ascend-sim";
      el.innerHTML = `
        <div class="ascend-sim-backdrop"></div>
        <div class="ascend-sim-container" role="dialog" aria-modal="true">
          <div class="ascend-sim-header">
            <span class="ascend-sim-icon" aria-hidden="true"></span>
            <h3 class="ascend-sim-title"></h3>
            <button class="ascend-sim-close" aria-label="Close">&times;</button>
          </div>
          <div class="ascend-sim-body">
            <p class="ascend-sim-desc"></p>
            <div class="ascend-sim-section ascend-sim-features-wrap" style="display:none">
              <h4>What's Included</h4>
              <ul class="ascend-sim-features"></ul>
            </div>
            <div class="ascend-sim-accompanying" style="display:none"></div>
            <div class="ascend-sim-price" style="display:none">
              <span class="ascend-sim-price-label"></span>
              <span class="ascend-sim-price-value"></span>
            </div>
          </div>
          <div class="ascend-sim-footer">
            <button class="ascend-sim-btn-close">Close</button>
            <button class="ascend-sim-btn-basket">💻 Add to Basket</button>
          </div>
        </div>
      `;
      document.body.appendChild(el);
      el.querySelector(".ascend-sim-backdrop").addEventListener("click", close);
      el.querySelector(".ascend-sim-close").addEventListener("click", close);
      el.querySelector(".ascend-sim-btn-close").addEventListener(
        "click",
        close,
      );
      document.addEventListener("keydown", function onKey(e) {
        if (e.key === "Escape" && el?.classList.contains("active")) close();
      });
    }

    // Populate content
    el.querySelector(".ascend-sim-icon").textContent = icon;
    // "Dissertation" + its configured accompaniment(s), shown as one
    // combined service the moment the customer opens it.
    el.querySelector(".ascend-sim-title").textContent = accompanyingServices.length
      ? `${name} + ${accompanyingServices.map((a) => a.name).join(" + ")}`
      : name;
    el.querySelector(".ascend-sim-desc").innerHTML = desc;

    const accompanyWrap = el.querySelector(".ascend-sim-accompanying");
    let accompanyingTotal = 0;
    if (accompanyingServices.length) {
      const fmt = (usd) => window.CurrencyService?.formatFromUSD?.(usd) ?? `$${usd}`;
      accompanyWrap.innerHTML = accompanyingServices
        .map((a) => {
          const amount = a.showingPrice ?? a.basePrice ?? 0;
          accompanyingTotal += amount;
          const hasPromo =
            a.originalPrice > 0 && a.salePrice > 0 && a.originalPrice > a.salePrice;
          const priceHtml = hasPromo
            ? `<span class="original">${fmt(a.originalPrice)}</span>${fmt(a.salePrice)}`
            : fmt(amount);
          return `
            <div class="ascend-sim-accompanying-item">
              <div class="ascend-sim-accompanying-item-name">
                <span><span class="plus-icon">+</span>${a.name}</span>
                ${a.note ? `<span class="ascend-sim-accompanying-item-note">${a.note}</span>` : ""}
              </div>
              <div class="ascend-sim-accompanying-item-price">${priceHtml}</div>
            </div>
            ${hasPromo ? `<p class="ascend-sim-accompanying-discount-note">${a.name}'s existing discount is already included above.</p>` : ""}`;
        })
        .join("");
      accompanyWrap.style.display = "";
    } else {
      accompanyWrap.innerHTML = "";
      accompanyWrap.style.display = "none";
    }

    const featWrap = el.querySelector(".ascend-sim-features-wrap");
    const featList = el.querySelector(".ascend-sim-features");
    if (features && features.length) {
      featList.innerHTML = features.map((f) => `<li>${f}</li>`).join("");
      featWrap.style.display = "";
    } else {
      featWrap.style.display = "none";
    }

    const priceBox = el.querySelector(".ascend-sim-price");
    if (price !== null && price !== undefined) {
      el.querySelector(".ascend-sim-price-label").textContent = accompanyingServices.length
        ? `${priceLabel} (combined)`
        : priceLabel;
      // Accompaniments are priced independently and simply summed into this
      // total — only possible when the base price is numeric (a pre-
      // formatted string can't be safely combined; the itemized lines above
      // still show each accompaniment's own price in that case).
      const formatted =
        typeof price === "string"
          ? price
          : window.CurrencyService?.formatFromUSD?.(price + accompanyingTotal) ??
            `$${(price + accompanyingTotal).toFixed(2)}`;
      el.querySelector(".ascend-sim-price-value").textContent = formatted;
      priceBox.style.display = "";
    } else {
      priceBox.style.display = "none";
    }

    el.querySelector(".ascend-sim-footer").style.display = showFooter
      ? ""
      : "none";

    // Basket button 📜 reset state, then wire
    const basketBtn = el.querySelector(".ascend-sim-btn-basket");
    basketBtn.className = "ascend-sim-btn-basket";
    basketBtn.innerHTML = "💻 Add to Basket";
    basketBtn.onclick = async function () {
      const id = serviceCode || name.toLowerCase().replace(/\s+/g, "-");
      const priceNum =
        typeof price === "number"
          ? price
          : parseFloat(String(price || "0").replace(/[^0-9.]/g, "")) || 0;
      if (
        window.UnifiedBasket &&
        typeof window.UnifiedBasket.addItem === "function"
      ) {
        const resolvedCategory =
          window.UnifiedBasket.normalizeCategory?.(category) ||
          window.UnifiedBasket.getCurrentCategory?.();
        const baseItem = { id, name, price: priceNum, category: resolvedCategory };
        await window.UnifiedBasket.addItem(baseItem);

        // Accompanying services are added as their own independent basket
        // line items — own category, own price, own discount if any —
        // tagged accompanimentOf so they skip the cross-service
        // "Combine Services?" prompt (this button already represents one
        // combined decision) and so the basket can recognize the pairing
        // later (see unified-basket.js addItem/showAccompanimentOverlapPrompt).
        for (const a of accompanyingServices) {
          const hasPromo =
            a.originalPrice > 0 && a.salePrice > 0 && a.originalPrice > a.salePrice;
          await window.UnifiedBasket.addItem({
            id: `${a.code}-accompaniment-${Date.now()}`,
            category: a.category,
            name: a.name,
            price: a.showingPrice ?? a.basePrice ?? 0,
            originalPrice: a.originalPrice || 0,
            salePrice: a.salePrice || 0,
            accompanimentOf: baseItem.id,
            accompanimentSourceService: id,
            accompanimentSourceServiceName: name,
            details: hasPromo
              ? `Includes ${a.name}'s existing discount`
              : `Accompanies ${name}`,
          });
        }
      }
      basketBtn.classList.add("in-basket");
      basketBtn.innerHTML = accompanyingServices.length
        ? "📜 All Added to Basket"
        : "📜 Added to Basket";
    };

    el.classList.add("active");
    document.body.style.overflow = "hidden";
    el.querySelector(".ascend-sim-close").focus();
  }

  window.AscendServiceModal = { show, close };
})();
